import Aos from "aos";
import React, { useEffect, useState } from "react";

const Faq = () => {
  const [activeIndexes, setActiveIndexes] = useState([0]); // Track active indexes
  useEffect(() => {
    Aos.init({ once: true });
  });

  const handleAccordionClick = (index) => {
    setActiveIndexes((prevIndexes) => {
      if (prevIndexes.includes(index)) {
        // If index is already active, remove it (close the accordion)
        return prevIndexes.filter((i) => i !== index);
      } else {
        // If index is not active, add it (open the accordion)
        return [...prevIndexes, index];
      }
    });
  };
  const accordionItems = [
    {
      title: "Čo je sofabed a ako sa líši od bežnej rozkladacej sedačky?",
      content:
        "Sofabed je špeciálna sedačka navrhnutá na každodenné spanie. Na rozdiel od bežných rozkladacích sedačiek má kvalitný matrac, pevnejšiu konštrukciu a jednoduchší mechanizmus rozkladu, čo zaručuje pohodlie ako pri klasickej posteli.",
    },
    {
      title: "Sú sofabedy vhodné na dlhodobé každodenné používanie?",
      content:
        "Áno, naše sofabedy sú navrhnuté tak, aby poskytovali maximálny komfort a podporu chrbtice aj pri dlhodobom používaní. Obsahujú kvalitné matrace s pamäťovou penou alebo HR penou.",
    },
    {
      title: "Aké typy matracov ponúkate?",
      content:
        "Na výber sú viaceré varianty matracov: \nPamäťová pena - prispôsobí sa telu a poskytne maximálnu oporu.\nHR pena - vysoká hustota peny pre dlhú životnosť a pevnejší pocit pri ležaní.",
    },
    {
      title: "Ako rýchlo sa dá sofabed rozložiť a zložiť?",
      content:
        "Vďaka praktickému mechanizmu je možné sofabed rozložiť za pár sekúnd, bez väčšej námahy a jedným ťahom.",
    },
    {
      title: "Je možné vybrať si poťahový materiál a farbu?",
      content:
        "Áno, ponúkame široký výber poťahových materiálov vrátane látky a pravej kože. Farbu si môžete zvoliť podľa svojich preferencií z nášho vzorkovníka.",
    },
    {
      title: "Aké sú rozmery sofabedov?",
      content:
        "Ponúkame rôzne veľkosti, od kompaktnejších modelov pre menšie priestory až po priestranné sofabedy pre dvoch s rozmermi lôžka až 160 x 198 cm.",
    },
    {
      title: "Ako sa starám o sofabed, aby vydržal čo najdlhšie?",
      content: "Pravidelne vysávajte a čistite poťah podľa odporúčaní predajcu. Matrac odporúčame pravidelne otáčať, aby sa rovnomerne opotreboval.",
    },
    {
      title: "Aká je dodacia lehota?",
      content: "Dodacia lehota závisí od dostupnosti modelu. Bežne je to približne 10 týždňov.",
    },
    {
      title: "Ponúkate aj dopravu a montáž?",
      content: "Áno, zabezpečujeme dopravu až k vám domov zdarma. Vynášku a montáž vieme zabezpečíť.",
    },
    {
      title: "Môžem si sofabed vyskúšať pred kúpou?",
      content: "Áno, náš sofabed si môžete vyskúšať v našej predjani v Martine. Odporúčame si osobne vyskúšať pohodlie sedenia aj spania.",
    },
  ];

  return (
    <>
      <div className="flex flex-col items-center mt-[40px] mb-[40px] gap-10 ">
        <div className=" flex justify-center self-stretch ">
          <div className="mx-auto items-center flex flex-col w-full max-w-6xl self-end xl:px-0 px-5">
            <h2
              className="mb-[15px] font-manrope text-[26px] font-semibold text-lime-500 relative inline p-[0] capitalize leading-[1]"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              Najčastejšie Kladené <span className="text-lime-900">Otázky</span>
            </h2>
          </div>
        </div>
        <div className="block mx-auto w-full max-w-6xl xl:px-0 px-5">
          <div className="flex flex-wrap -mx-[15px]">
            <div className="lg:w-[40%] w-full px-[12px]">
              <div className=" p-[30px]   my-[0] mx-auto bg-[#fff] rounded-[5px]">
                <img src="assets/Images/emma4.jpg" className="w-full" alt="" />
              </div>
            </div>
            <div className="lg:w-[60%] w-full px-[12px]">
              <div className=" p-[30px]   my-[0] mx-auto bg-[#fff] rounded-[5px]">
                <div
                  className="flex-col "
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  {accordionItems.map((item, index) => (
                    <div className="accordion__item" key={index}>
                      <div
                        className="p-[18px] flex flex-1 flex-col gap-3 border rounded-[10px] border-solid border-gray-200_01 mb-[10px]"
                        onClick={() => handleAccordionClick(index)}
                      >
                        <div className="w-full">
                          <div className="">
                            <div className="flex items-center justify-between gap-5">
                              <p
                                className={`md:text-[18px] text-[20px] font-medium text-black-900 ${
                                  activeIndexes.includes(index) ? "active" : ""
                                }`}
                              >
                                {item.title}
                              </p>
                              <button
                                className={`rounded-[12px] w-[24px] px-1.5 flex flex-row items-center rotate-180  justify-center text-center cursor-pointer whitespace-nowrap rounded-[50%] h-[24px] px-1.5 bg-gray-200_03 ${
                                  activeIndexes.includes(index)
                                    ? "active rotate-0"
                                    : ""
                                }`}
                              >
                                <img
                                  src="assets/Images/arrowdown.svg"
                                  className=""
                                  alt=""
                                />
                              </button>
                            </div>
                          </div>
                        </div>

                        {activeIndexes.includes(index) && (
                          <div>
                            <div>
                              <p className="text-[16px] font-normal leading-6 text-gray-600_01">
                                {item.content}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
